import { hide, show, toggleClass, emptyNode } from 'Components/domHelpers';
import { RefFormData } from 'Components/FormComponents';
import s from './strings';

export class ValidatedForm extends RefFormData {
  constructor({ ctrl, styleFields = true }) {
    super();

    this._ctrl = ctrl;
    this._styleFields = styleFields;

    this._ctrl.on('update', () => {
      Object.entries(this._ctrl.state).forEach(([ fieldName, state ]) => {
        this._styleField(fieldName, state);
      });
    });
  }

  init() {
    this._icons = {};

    this._ctrl.fields.forEach(field => {
      const { name: fieldName } = field;
      const { el } = this.fields[fieldName];

      if (el instanceof RefFormData) {
        return;
      }

      if (this._styleFields && this._shouldStyle(el)) {
        const icon = (
          <span class="form-control-feedback" aria-hidden="true" />
        );

        this._icons[fieldName] = icon;

        el.after(icon);

        const fg = el.closest('.form-group');
        fg.classList.add('has-feedback');

        if (field.rules.required) {
          const label = fg.querySelector('.control-label');
          if (label) {
            label.textContent += '*';
          }
        }
      }

      if (el && el.type !== 'checkbox' && !field.rules.noCheckInteractive) {
        el.onblur = () => this._ctrl.checkInteractive(this, fieldName, 'blur');
        el.onkeyup = () => this._ctrl.checkInteractive(this, fieldName, 'keyup');
      }
    });
  }

  _styleField(fieldName, result) {
    const { el } = this.fields[fieldName];

    if (!this._styleFields || !this._shouldStyle(el)) {
      return;
    }

    const parent = el.parentNode;
    const icon = this._icons[fieldName];

    parent.classList.remove('has-success');
    parent.classList.remove('has-error');

    icon.classList.remove('tbicon-check');
    icon.classList.remove('tbicon-cross');

    if (result === null) {
      return;
    }

    if (result === 'valid') {
      parent.classList.add('has-success');
      icon.classList.add('tbicon-check');

      return;
    }

    parent.classList.add('has-error');
    icon.classList.add('tbicon-cross');
  }

  _shouldStyle(el) {
    if (!el)
      return false;

    if (el instanceof RefFormData || el instanceof HTMLSelectElement ||
        (el instanceof HTMLInputElement && el.type === 'checkbox')) {
      return false;
    }

    return true;
  }
}

export class FormErrorList {
  static isClassComponent = true;

  constructor({ ctrl, icon = true, hideType = 'hidden' }) {
    this._hideType = hideType;

    this._curErrors = undefined;

    this.root = (
      <div classList={{ alert: true, 'alert-danger': true, 'alert-icon': icon }}></div>
    );

    const update = () => this._render(ctrl.errors);
    ctrl.on('update', update);
    update();
  }

  _render(error) {
    if (this._curErrors === error) {
      // no change, exit early
      return;
    }
    this._curErrors = error;

    if (!error || !error.length) {
      this._hide();
      return;
    }

    emptyNode(this.root);

    let singleMessage = false;
    if (Array.isArray(error)) {
      if (error.length === 1) {
        singleMessage = error[0].message;
      }
    } else {
      singleMessage = error;
    }

    if (singleMessage) {
      this.root.textContent = singleMessage;
    } else {
      this.root.appendChild(
        <div>
          <p>{s.FormErrorList.msg}</p>

          <ul>
            {error.map(err => <li>{err.message}</li>)}
          </ul>
        </div>
      );
    }

    this._show();
    window.scrollTo(0, 0);
  }

  _show() {
    switch (this._hideType) {
    case 'hidden':
      show(this.root);
      break;

    case 'invisible':
      toggleClass(this.root, 'invisible', false);
      break;
    }
  }

  _hide() {
    switch (this._hideType) {
    case 'hidden':
      hide(this.root);
      break;

    case 'invisible':
      toggleClass(this.root, 'invisible', true);
      break;
    }
  }
}
